import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CoreModule } from './core/core.module';
import { FormsModule, ReactiveFormsModule}   from '@angular/forms';

import { AngularFireModule } from 'angularfire2';
import { AngularFirestoreModule } from 'angularfire2/firestore';
import { AngularFireStorageModule } from 'angularfire2/storage';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { environment } from '../environments/environment';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SortableModule } from '@progress/kendo-angular-sortable';

import { AppComponent } from './app.component';
import { DropZoneDirective } from './card/new/directive/drop-zone.directive';
import { FileUploadComponent } from './card/new/file-upload/file-upload.component';
import { FileSizePipe } from './card/new/pipe/file-size.pipe';
import { AppRoutingModule } from './/app-routing.module';
import { DashboardComponent } from './card/dashboard/dashboard.component';
import { SignUpComponent } from './sign-up/sign-up.component';
import { LoginComponent } from './login/login.component';
import { IntroComponent } from './intro/intro.component';
import { NotFoundComponent } from './error/not-found/not-found.component';
import { ContactComponent } from './form/contact/contact.component';
import { ListComponent } from './form/list/list.component'


@NgModule({
  declarations: [
    AppComponent,
    DropZoneDirective,
    FileUploadComponent,
    FileSizePipe,
    DashboardComponent,
    SignUpComponent,
    LoginComponent,
    IntroComponent,
    NotFoundComponent,
    ContactComponent,
    ListComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    CoreModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule,
    AngularFireStorageModule,
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    BrowserAnimationsModule,
    SortableModule,
    AppRoutingModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/Users/homePC/angular-comp/The-Top/src/app/app.module.ts